// API service for SSC Ready Mix CMS integration
// Falls back to mock data if the CMS is unreachable (useful during development)

import * as MOCK from "./mock";

const CMS_URL = process.env.REACT_APP_CMS_URL || "";
const API_BASE = CMS_URL ? `${CMS_URL.replace(/\/$/, "")}/api` : "";

async function request(path, options = {}) {
  if (!API_BASE) throw new Error("CMS URL not configured");
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) throw new Error(`API ${res.status}`);
  const json = await res.json();
  return json.data;
}

async function safe(path, fallback) {
  try { return await request(path); } catch (e) { console.warn(`[API fallback] ${path}:`, e.message); return fallback; }
}

// ============ GET APIs (fallback to mock) ============
export const getProducts     = () => safe("/products",     MOCK.PRODUCTS.map((p,i)=>({ id:i+1, ...p, grades: p.grades.join(',') })));
export const getProjects     = () => safe("/projects",     MOCK.WORKS.map((w,i)=>({ id:i+1, title:w.title, client:w.client, description:w.desc, image:w.img })));
export const getBlogs        = () => safe("/blogs",        MOCK.BLOGS.map((b,i)=>({ id:i+1, slug:`post-${i+1}`, title:b.title, excerpt:b.excerpt, image:b.img, published_at:b.date })));
export const getBlogBySlug   = (slug) => safe(`/blogs/${slug}`, null);
export const getGallery      = () => safe("/gallery",      MOCK.GALLERY_IMAGES.map((src,i)=>({ id:i+1, image:src })));
export const getTestimonials = () => safe("/testimonials", MOCK.REVIEWS.map((r,i)=>({ id:i+1, name:r.name, company:r.company, content:r.text, rating:5 })));
export const getClients      = () => safe("/clients",      MOCK.CLIENTS.map((c,i)=>({ id:i+1, name:c.name, logo:c.src })));
export const getSettings     = () => safe("/settings",     {
  company_name: "SSC Ready Mix",
  tagline: "Engineered for Strength",
  top_bar_text: "SSC · READY MIX CONCRETE · ENGINEERED FOR STRENGTH",
  phone: "+91 9861 934 840",
  phone_secondary: "",
  email: "",
  sales_email: "sales@sscreadymix.in",
  support_email: "support@sscreadymix.in",
  whatsapp: "+919861934840",
  whatsapp_message: "Hello, I am interested in SSC Ready Mix concrete.",
  hours: "Mon – Sat · 9:00 AM – 7:00 PM",
  plant_1: "Plot no. 1205, Nuahat Telengapentha, Cuttack-Bhubaneswar Rd, Odisha 754001",
  plant_2: "Plot No. 441, Janla, Alakar, Odisha 752054",
  plant_3: "Plot No. 1795, Patia, Chandaka, Bhubaneswar, Odisha 751024",
  hero_poster: "https://images.unsplash.com/photo-1599995903128-531fc7fb694b?w=1920&q=80",
  hero_video: "https://cdn.pixabay.com/video/2020/09/08/49375-457952419_large.mp4",
  stat_cubic_meters: "200K+",
  stat_years: "15+",
  stat_plants: "3",
  stat_projects: "150+",
  // SEO
  seo_site_title: "SSC Ready Mix · Premium Ready-Mix Concrete",
  seo_meta_description: "SSC Ready Mix is a premier ready-mix concrete producer engineered for strength, precision and on-time delivery. Custom mixes, NHAI/IRC approved, three plants in Odisha.",
  seo_meta_keywords: "ready mix concrete, RMC, M20, M25, M30, M40, concrete supplier, Odisha, Cuttack, Bhubaneswar, NHAI approved",
  seo_og_image: "https://images.unsplash.com/photo-1599995903128-531fc7fb694b?w=1200&q=80",
  seo_og_url: "https://sscreadymix.in",
  seo_twitter_handle: "@sscreadymix",
  // Social
  social_facebook: "#",
  social_instagram: "#",
  social_linkedin: "#",
  social_twitter: "#",
  social_youtube: "#",
  social_whatsapp_url: "https://wa.me/919861934840",
});

// ============ POST APIs ============
export const submitInquiry = (data) => {
  if (!API_BASE) return Promise.resolve({ ok: true, mock: true });
  return fetch(`${API_BASE}/inquiries`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(r => r.json());
};

export const subscribeNewsletter = (email) => {
  if (!API_BASE) return Promise.resolve({ ok: true, mock: true });
  return fetch(`${API_BASE}/newsletter`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  }).then(r => r.json());
};

export const CMS_CONFIGURED = Boolean(CMS_URL);
